module.exports = __webpack_public_path__ + "img/chatkit-advanced.b0a0af1d.png";